import { FormatEditor } from "@/components/FormatEditor";

const PLACEHOLDERS = [
  "company_name", "date", "proposal_no",
  "logo_url", "signature_url",
  "customer_name", "customer_phone", "customer_email",
  "address", "city", "tehsil", "pincode",
  "loan_type", "loan_amount", "lender_name", "partner_name", "sanction_amount", "lead_id",
];

export default function ProposalFormat() {
  return (
    <FormatEditor
      title="Proposal Format"
      desc="Edit the HTML template used for loan proposals. Upload logo & signature below and reference them via {{logo_url}} and {{signature_url}} inside <img> tags."
      endpoint="/settings/proposal-format"
      placeholders={PLACEHOLDERS}
      testId="proposal-format-page"
      showLetterheadAssets
    />
  );
}
